<template>
  <div class="page-flatpage">
    <main class="main">
      <div class="breadcrumb">
        <router-link :to="{ name: 'home' }" title="Retour à la page d'accueil">
          Accueil
        </router-link>
        <span>
          {{ flatpage.title }}
        </span>
      </div>

      <div class="main-content">
        
        <article>
          <subscription-ad-card v-if="!flatpage.public"> </subscription-ad-card>
          <div>
            <h1 class="bold">{{ flatpage.title }}</h1>
            <div class="rte" :class="(authenticated && hasActiveSubscription) || flatpage.public ? '' : 'blur pointer-events-none'" v-html="flatpage.text"></div>
          </div>
        </article>
        <!-- <right-bar>
          
        </right-bar> -->
      </div>
    </main>
  </div>
</template>

<script>
import Flatpage from '@/api/flatpages.js'
import SubscriptionIncentiveCard from '@/components/SubscriptionIncentiveCard.vue'
import SubscriptionAdCard from '@/components/SubscriptionAdCard'

import RightBar from '@/components/RightBar.vue'

export default {
  components: { SubscriptionIncentiveCard, RightBar, SubscriptionAdCard },
  name: 'Flatpage',

  data () {
    return {
      flatpage: {},
    }
  },

  created () {
    this.reset()
  },

  beforeRouteUpdate (to, from, next) {
    this.retrieveFlatpage({ url: to.path })
    next()
  },

  methods: {
    reset () {
      this.retrieveFlatpage({ url: this.currentRoutePath })
    },

    retrieveFlatpage (params) {
      Flatpage.retrieve(params).then((response) => {
        this.flatpage = response
      })
    }
  },

  computed: {
    currentRoutePath () {
      return this.$route.path
    },
    authenticated () {
      return this.$store.getters['authent/isAuthenticated']
    },

    hasActiveSubscription () {
      return this.$store.getters['authent/hasActiveSubscription']
    },

  },

  watch: {
    currentRoutePath () {
      this.reset()
    }
  }
}
</script>
<style>

.rte a {
  display: inline-block;
  word-break: break-word;
}

</style>
